import type { ReactNode } from 'react';
import React, { Children } from 'react';

import { StaticActions } from '../actions';
import type { TFieldsOrder } from '../models';

/** Проходит по чайлдам и собирает name в массив, чтобы сохранять порядок полей */
export const getFieldsOrder: TFieldsOrder = (children, inputsOrder) => {
    if (inputsOrder) {
        return { fieldsOrder: inputsOrder };
    }

    const fieldsOrder: string[] = [];

    const count = (childs: ReactNode) =>
        Children.forEach(childs, child => {
            if (!React.isValidElement(child)) return;

            const { children: elChildren, name } = child.props;

            if (typeof name === 'string') {
                fieldsOrder.push(name);
            } else if (typeof name === 'object') {
                const names = StaticActions.getNames(name);

                Object.getOwnPropertyNames(names).forEach(val => {
                    fieldsOrder.push(val);
                });
            }

            // Рекурсивно пройти по чилдам
            if (elChildren) count(elChildren);
        });

    count(children);

    return { fieldsOrder };
};
